//Components
import { CustomInput, CustomInputWithDropdown, CustomButton, CustomerSelectWithSearch } from "../../../../Forms"

const Component = ({
  formValues,
  areas,
  onChange,
  onSelect,
  provinces,
  suburbs,
  cities,
  disabledBtn,
  onSave,
  onChangePhoneNumber
}) => {
  return (
    <div className="add-address-body">
      <p className="header">Add Pick-up Address</p>
      <div className="form-wrapper">
        <CustomInput
          title="Save Address As"
          name={"alias"}
          value={formValues.alias.value}
          placeholder="Enter alias (eg. ship to house or ship to office)"
          onChange={onChange}
        />
        <CustomInput
          title="Sender"
          value={formValues.full_name.value}
          name="full_name"
          placeholder="Enter Sender Name"
          onChange={onChange}
        />
        <CustomInputWithDropdown
          title="Mobile Number"
          placeholder="Enter Mobile Number"
          value={formValues.phone_number.value}
          selectValue={formValues.phone_number.selectValue}
          onChange={onChangePhoneNumber}
          name="phone_number"
          type="number"
        />
        <CustomInput
          title="Address"
          value={formValues.address.value}
          name="address"
          placeholder="Enter Address Detail"
          onChange={onChange}
        />

        <div className="horizontal-wrapper">
          <CustomerSelectWithSearch
            className="horizontal"
            title="Country"
            value={formValues.country.value}
            onChange={() => null}
            placeholder="Select Country"
            name="country"
            options={[]}
            onSelect={() => null}
          />
          <CustomerSelectWithSearch
            className="horizontal"
            title="State/Province"
            value={formValues.province.value}
            name="province"
            onChange={onChange}
            placeholder="Select State/Province"
            options={provinces}
            onSelect={onSelect}
          />
        </div>

        <div className="horizontal-wrapper">
          <CustomerSelectWithSearch
            className="horizontal"
            title="City"
            name="city"
            onChange={onChange}
            options={cities}
            value={formValues.city.value}
            placeholder="Select City"
            onSelect={onSelect}
          />
          <CustomerSelectWithSearch
            options={suburbs}
            className="horizontal"
            onChange={onChange}
            title="District"
            value={formValues.suburb.value}
            placeholder="Select District"
            onSelect={onSelect}
            name="suburb"
          />
        </div>

        <div className="horizontal-wrapper">
          <CustomerSelectWithSearch
            className="horizontal"
            title="Sub-District"
            placeholder="Select Sub-District"
            name="area"
            value={formValues.area.value}
            options={areas}
            onSelect={onSelect}
            onChange={onChange}
          />
          <CustomInput
            className="horizontal"
            title="Enter ZIP Code"
            placeholder="Select Enter ZIP Code"
            name={"postal_code"}
            value={formValues.postal_code.value}
            onChange={onChange}
            type="number"
          />
        </div>
        <CustomInput
          className="custom-textarea"
          title="Note"
          value={formValues.note.value}
          name="note"
          type="textarea"
          onChange={onChange}
          placeholder="Enter your note here (optional)"
        />
      </div>
      <CustomButton
        className="add-address-btn"
        disabled={disabledBtn}
        text={"Save"}
        onClick={onSave}
      />
    </div>
  )
}

export default Component;